import bilAPI from "../api";

export const getObjectives = ({ signal }) => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get(`/questions/question_objectives/`, { signal })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject("axios error");
        });
    } catch (error) {
      reject("system error");
    }
  });
};
